/* eslint-disable no-console */
import { put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { uniq } from 'lodash';
import { push } from 'react-router-redux';
import { setNotification, IMPORT_ROUTE } from 'utils';
import { getUsersApi } from '../api/userApi';
import * as ImportApis from '../api/importApi';
import * as ImportTypes from '../types/importTypes';
import * as ImportActions from '../actions/importActions';

const getLayout = state => state.layout;
const getImports = state => state.imports;

// L O A D   I M P O R T S
function* loadImportsSaga(action) {
    const { offset, limit, sort, filters } = yield select(getImports);

    try {
        const params = { offset, limit };

        const sendFilters = {};

        if (filters.file !== '') {
            sendFilters.file = {
                operator: 'typing',
                value: filters.file,
            };
        }

        if (filters.status !== '') {
            sendFilters.status = filters.status;
        }

        if (filters.created_by.length > 0) {
            sendFilters.created_by = filters.created_by;
        }

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'file') {
                params.sort_by = JSON.stringify({ file: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        params.filter = JSON.stringify({ ...sendFilters, ...action.data });

        const result = yield ImportApis.getImportsApi(params);

        if (result.status === 200) {
            const paramUsers = {
                filter: JSON.stringify({ _id: uniq(result.data.hits.map(h => h.created_by)) }),
            };
            const getUsers = yield getUsersApi(paramUsers);

            yield put(ImportActions.loadImportsRes({
                ...result.data,
                displayUsers: getUsers.data.hits,
            }));
        } else {
            yield put(ImportActions.loadImportsErr());
        }
    } catch (e) {
        yield put(ImportActions.loadImportsErr());
        console.log(e);
    }
}

export function* loadImportsWatcher() {
    yield takeLatest(ImportTypes.LOAD_IMPORTS, loadImportsSaga);
}
// L O A D   I M P O R T S


// A D D   N E W   I M P O R T
function* addNewImportSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const { type } = action.data[0];

        for (let i = 0; i < action.data.length; i += 1) {
            const file = action.data[i];
            const result = yield ImportApis.addNewImportApi(file);

            if (result.status === 202) {
                yield put(ImportActions.addNewImportRes('SENDING'));
            } else {
                setNotification('error', locale, 'global.error', 'imports.upload.error', { name: file.name });
            }
        }

        yield delay(action.data.length * 200);

        yield put(ImportActions.addNewImportRes('SUCCESS', null, null));
        setNotification('success', locale, 'global.success', 'imports.upload.success');

        yield put(push(IMPORT_ROUTE[type]));
    } catch (e) {
        yield put(ImportActions.addNewImportErr());
        setNotification('error', locale, 'global.error', 'error.login.error');
        console.log(e);
    }
}

export function* addNewImportWatcher() {
    yield takeLatest(ImportTypes.ADD_NEW_IMPORT, addNewImportSaga);
}
// A D D   N E W   I M P O R T
